import { render } from "./TierAutoUpgradeBlock.vue?vue&type=template&id=7b9defca&scoped=true"
import script from "./TierAutoUpgradeBlock.vue?vue&type=script&lang=ts"
export * from "./TierAutoUpgradeBlock.vue?vue&type=script&lang=ts"

import "./TierAutoUpgradeBlock.vue?vue&type=style&index=0&id=7b9defca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7b9defca"

export default script